import React from 'react'
import t from 'prop-types'
import { css } from 'linaria'
import { Link } from 'gatsby'
import Image from '../../Images/Image'
import LabelList from '../../Labels/LabelList'
import Avatar from '../../Avatar'
import StatSmall from '../../Infographics/StatSmall'

const cardImage = css`
  mix-blend-mode: multiply;
`

const headingWrap = css`
  .heading--hover {
    background-image: linear-gradient(180deg, transparent 70%, #8bd0ff 0);
    background-size: 0 100%;
  }
  &:hover {
    .heading--hover {
      background-size: 100% 100%;
    }
  }
`

const imageWrap = css`
  &:hover {
    .${cardImage} {
      filter: grayscale(100%);
    }
  }
`

const CardFeature = ({
  author,
  heading,
  image,
  logo,
  labels,
  link,
  stat,
  subheading,
}) => {
  return (
    <article className="md:grid md:grid-cols-5 lg:grid-cols-3 md:gap-20 md:items-center">
      <div className="md:col-span-3 lg:col-span-2">
        <Link
          className={`${imageWrap} mask-image relative group overflow-hidden block bg-transparent hover:bg-blue-200 focus:bg-blue-200 transition ease-out duration-500 rounded-l-xl sm:rounded-l-2xl`}
          to={link.url}
        >
          {logo && (
            <div className="absolute top-0 left-0 z-10 flex items-center justify-center w-full h-full bg-gray-700 bg-opacity-60 group-hover:bg-opacity-0 transition-bg-opacity ease-out duration-500">
              <Image {...logo}></Image>
            </div>
          )}
          <Image
            className={`${cardImage} z-0 block w-full h-auto group-hover:opacity-90 transition-image ease-out duration-500`}
            {...image}
          />
        </Link>
      </div>
      <div className="md:order-first md:col-span-2 lg:col-span-1 md:grid md:justify-center md:content-center">
        {labels && (
          <div className="mt-4 md:mt-0">
            <LabelList labels={labels} />
          </div>
        )}
        <Link className={headingWrap} href={link.url}>
          {heading && (
            <h3 className="mt-3 md:mt-4 text-2xl md:text-3x lg:text-4xl leading-tight font-serif font-bold text-gray-700">
              <span className="heading--hover bg-no-repeat transition-bg-size ease-in-out duration-500">
                {heading}
              </span>
            </h3>
          )}

          {subheading && (
            <p className="mt-3 text-base lg:text-lg leading-normal font-sans font-normal text-gray-600">
              {subheading}
            </p>
          )}
        </Link>
        {author && (
          <div className="mt-6 md:mt-8">
            <Avatar {...author} isSmall></Avatar>
          </div>
        )}
        {stat && (
          <div class="mt-4 pt-4 border-t border-gray-400">
            <StatSmall {...stat}></StatSmall>
          </div>
        )}
      </div>
    </article>
  )
}

CardFeature.propTypes = {
  author: t.object,
  heading: t.string,
  image: t.object,
  logo: t.object,
  labels: t.object,
  link: t.object,
  stat: t.object,
  subheading: t.string,
}

CardFeature.defaultProps = {}

export default CardFeature
